import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Card, CardBody } from "@heroui/react";
import { Icon } from "@iconify/react";
import useStore from "../store/useStore";
import { getLogoBase64 } from "../utils/themeManager";

export function CompaniesPage() {
  const history = useHistory();
  const { authUser, setSelectedCompany } = useStore();

  useEffect(() => {
    if (!authUser || !authUser?.contato?.empresaLista?.length) {
      history.push("/login");
    }
  }, [authUser, history]);

  const handleSelectCompany = async (company: { id: string; nome: string }) => {
    setSelectedCompany({ id: company.id, nome: company.nome });
    
    history.push("/messages");
  };

  if (!authUser) {
    return null;
  }

  return (
    <div
      className="min-h-screen flex flex-col relative bg-primary-500"
    >
      <div
        className="absolute top-0 left-0 right-0 h-1/2"
        style={{
          zIndex: 1,
        }}
      />

      <div className="pt-12 pb-6 flex justify-center relative z-10" style={{ paddingTop: "10rem" }}>
        <img src={getLogoBase64()} alt="PlayBPO" className="h-24" />
      </div>

      <div className="px-6 pb-6 flex-1 relative z-10">
        <h2 className="text-2xl mb-6 text-secondary text-center">
          Selecione uma empresa
        </h2>

        <div className="space-y-4 max-w-md mx-auto max-h-[calc(100vh-300px)] overflow-y-auto p-4">
          {authUser.contato.empresaLista.map((company) => (
            <Card
              key={company.id}
              isPressable
              onPress={() => {
                console.log({company})
                handleSelectCompany(company)
              }}
              className="w-full bg-white"
              style={{ borderRadius: 20 }}
            >
              <CardBody className="p-5">
                <div className="flex justify-between items-center">
                  <h3 className="font-medium text-gray-800">{company.nome}</h3>
                  <Icon icon="lucide:chevron-right" className="text-gray-400" />
                </div>
              </CardBody>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
